import React from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';
import clsx from 'clsx';

import { useProductThumbnail } from '@domains/pdp-common';

import { RelatedStylistListHeader } from '../components/Header';
import { RelatedStylistCarousel } from '../components/RelatedStylistCarousel';
import { useRelatedStylistListService } from '../services/useRelatedStylistListService';

interface RelatedStylistListContainerProps {
  className?: string;
}

export const RelatedStylistListContainer: React.FC<React.PropsWithChildren<RelatedStylistListContainerProps>> = ({
  className,
}) => {
  const { image_list } = useProductThumbnail();
  const {
    targetRef,
    visible,
    classnameTotalPage,
    list,
    mainTitle,
    currentIndex,
    handleSlideChange,
    onSavedProduct,
    handleClick,
    handleImpression,
  } = useRelatedStylistListService();

  const imageList = (!!image_list.length && image_list[0].static_url) || '';

  if (!list.length) {
    return null;
  }

  return (
    <Container ref={targetRef} className={clsx([className, classnameTotalPage])}>
      {visible && (
        <>
          <RelatedStylistListHeader main_title={mainTitle} image_url={imageList} />
          <RelatedStylistCarousel
            list={list}
            currentIndex={currentIndex}
            handleSlideChange={handleSlideChange}
            onClick={handleClick}
            onImpression={handleImpression}
            onSavedProduct={onSavedProduct}
          />
        </>
      )}
    </Container>
  );
};

const Container = styled.div`
  border-top: 8px solid ${vars.v3Color.gray100};
  padding-top: 4px;
`;
